import React from "react";

interface DashboardLabelProp {
  label: string;
}

const DashboardLabel: React.FC<DashboardLabelProp> = ({ label }) => {
  return (
    <p className="text-black4">{label}</p>
  );
};
export default DashboardLabel;
